<template>
  <div class="mybar_content">
    <ul class="list">
      <li class="item" @click="$router.push({ path: '/pay' })">
        <img src="../../assets/images/cz.png" alt="" />
        <p>平台充值</p>
      </li>
      <li class="item" @click="$router.push({ path: '/myGift' })">
        <img src="../../assets/images/lb.png" alt="" />
        <p>我的礼包</p>
      </li>
      <li class="item" @click="$router.push({ path: '/rechargeRecord' })">
        <img src="../../assets/images/jl.png" alt="" />
        <p>充值记录</p>
      </li>
      <li class="item" @click="$router.push({ path: '/messageCenter' })">
        <img src="../../assets/images/xx.png" alt="" />
        <p>我的消息</p>
      </li>
      <li class="item" @click="$router.push({ path: '/myCoupon' })">
        <img src="../../assets/images/yhj2.png" alt="" />
        <p>优惠券</p>
      </li>
      <li class="item">
        <img src="../../assets/images/kf.png" alt="" />
        <p>在线客服</p>
      </li>
      <li class="item" @click="$router.push({ path: '/phoneBind' })">
        <img src="../../assets/images/bd.png" alt="" />
        <p>手机绑定</p>
      </li>
      
      <li class="item" @click="$router.push({ path: '/centerLogin' })">
        <img src="../../assets/images/aqzx.png" alt="" />
        <p>安全中心</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less"  scoped>
.mybar_content {
  margin-top: 5vw;
  ul {
    height: 34.1333vw;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: row;
    flex-wrap: wrap;
    background: #fff;
    border-radius: 3vw;
    li {
      flex: 25%;
      img {
        width: 5.7333vw;
        height: 5.7333vw;
        margin-bottom: 2vw;
      }
      P {
        font-size: 3.5vw;
      }
    }
  }
}
</style>